import { yupResolver } from '@hookform/resolvers/yup';
import { IMiscellaneousFormMeta } from '@Modules/admin/archiving/containers/formHandlers/consultationAuthorizationsDetails/miscellaneous/MiscellaneousFormMeta';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  meta: IMiscellaneousFormMeta,
} & TFormUIProps;

const MiscellaneousFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  const fields = getFormFieldsName(meta);
  const datesInformations = fields.slice(0, 4);
  const cutOffInformations = fields.slice(4, 7);
  const countriesInformations = fields.slice(7, 11);
  const institutionIdInformations = fields.slice(11, 15);
  const othersInformations = fields.slice(15, 22);

  

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CC.Heading size="md">Divers</CC.Heading>
      <CC.Flex
        direction={{  base: 'column' }}
        gap={"16px"}
        mt={"20px"}
      >
        <CustomFieldSet title={"Dates"}>
          <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={4}>              
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
              datesInformations
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title={"Suspension"}>
          <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={4}>
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
              cutOffInformations
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title={"Pays"}>
          <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={4}>              
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
              countriesInformations
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title={"ID Institution"}>
          <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={4}>              
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
              institutionIdInformations
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title={"Autres"}>
          <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={4}>              
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
              othersInformations
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

      </CC.Flex>

      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default MiscellaneousFormUI;
